// import { useAppStore } from "@/store/AppStore";
export function useAgwManagerService() {
  async function fetchJson(url, options) {
    let json = {};
    // const appStore = useAppStore();
    try {
      // const csrfToken = appStore.csrfToken;
      // console.log("token in AgwManagerService: ", csrfToken);
      // console.log("options before change: ", options);
      // options.headers["ObSSOCookie"] = csrfToken;
      // console.log("options after change: ", options);
      const response = await fetch(import.meta.env.VITE_ID_COCKPIT_URL+url, options);
      // console.log("response: ", response);
      json = await response.json();
      if (! json.errors && !json.result) {
        console.log("Malformed response: ", json);
        return {errors: [{message: "Malformed response"}]};
      }
    }
    catch (err) {
      console.log("Error making backend call: ", err);
      return {errors: [{message: "Failed to make backend call"}]};
    }
    return json;
  }

  return {fetchJson};
}
